const IDENTIFICATION_VALIDATORS = {
  DNI: {
    regex: /^\d{7,8}$/,
    normalize: (value) => value.replace(/\s+/g, ""),
    message: "El DNI debe tener 7 u 8 dígitos numéricos.",
  },
  PASAPORTE: {
    regex: /^[A-Z0-9]{6,9}$/,
    normalize: (value) => value.replace(/\s+/g, "").toUpperCase(),
    message: "Ingresá de 6 a 9 caracteres alfanuméricos en mayúscula.",
  },
  "CEDULA EXTRANJERA": {
    regex: /^[A-Za-z0-9]{6,12}$/,
    normalize: (value) => value.replace(/\s+/g, ""),
    message: "La cédula extranjera debe tener entre 6 y 12 caracteres alfanuméricos.",
  },
};

function resolveTypeName(type) {
  if (!type) return null;
  if (typeof type === "string") {
    return type.trim().toUpperCase();
  }

  if (typeof type === "object") {
    const candidate = type.nombre || type.name || type.descripcion || type.tipo;
    return candidate ? candidate.toString().trim().toUpperCase() : null;
  }

  return type.toString().trim().toUpperCase();
}

export function validateIdentificationByType(type, value) {
  const normalizedType = resolveTypeName(type);
  const validator = normalizedType ? IDENTIFICATION_VALIDATORS[normalizedType] : null;

  if (value == null || value === "") {
    return {
      valid: true,
      formattedValue: "",
      message: null,
    };
  }

  const rawValue = typeof value === "string" ? value : String(value ?? "");
  const trimmedValue = rawValue.trim();
  const formattedValue = validator?.normalize ? validator.normalize(trimmedValue) : trimmedValue;

  if (!validator) {
    return {
      valid: true,
      formattedValue,
      message: null,
    };
  }

  if (!validator.regex.test(formattedValue)) {
    return {
      valid: false,
      formattedValue,
      message: validator.message,
    };
  }

  return {
    valid: true,
    formattedValue,
    message: null,
  };
}

export const identificationValidators = {
  resolveTypeName,
  validateIdentificationByType,
};
